module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/lottie/truck-loading-1c09f8c616e3e3c0cd4c0bd907795b82.lottie";